import ESSDocumentList from './ESSDocumentList.vue';

export default ESSDocumentList;


// WEBPACK FOOTER //
// ./src/components/ESSProfile/ESSComponents/DocumentList/index.js